module.exports = __webpack_public_path__ + "img/feedback_wrong_light.b2aecc2d.png";